import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Badge, Button } from '@mui/material';
import { useQuery } from '@apollo/client';
import { gql } from '@apollo/client';
import { useAuth } from '../../contexts/AuthContext';

const GET_PENDING_REVIEW_COUNT = gql`
  query GetPendingReviewCount {
    authenticatedGuest {
      id
      pendingReviews {
        id
      }
    }
  }
`;

export const ReviewsLink = () => {
  const { guest } = useAuth();
  const { data } = useQuery(GET_PENDING_REVIEW_COUNT, {
    skip: !guest,
  });

  const count = data?.authenticatedGuest?.pendingReviews?.length ?? 0;

  return (
    <Button
      component={RouterLink}
      to="/guests/reviews"
      sx={{ color: 'text.primary' }}
    >
      <Badge
        badgeContent={count}
        color="error"
        invisible={count === 0}
      >
        Reviews
      </Badge>
    </Button>
  );
};
